import { Modes } from "../constants/modes";
import { ScormEntry } from "./ScormEntry";

export class ScormSession {
  id: number;
  objectId: string;
  userProfileId: string;
  forename: string;
  surname: string;
  scormEntries: ScormEntry[];
  saving: boolean = false;
  open: boolean = undefined;
  mode: Modes = Modes.Tracked;
  learnerCourseLogId: number;
  completed: boolean = false;
  module?: number = 0;

// Additional element to include contentObject path detail
// this was added instead of ContentObject to limit data exchanges
// to what is only needed for now
  contentObjectPath : string;

}
